import { Popup, PopupBody, PopupFooter } from '../controls';

export interface IssuerDescriptionPopupProps {
    issuer: string;
    issuerDescription: string;
    onClose: () => void;
}

export function IssuerDescriptionPopup({ issuer, issuerDescription, onClose }: IssuerDescriptionPopupProps) {
    return (
        <Popup
            modalClass="modal-issuer-description"
            title="Issuer Description"
            renderTitle={<span className="name-tag">{issuer}</span>}
            onClose={onClose}
            renderInBody
        >
            <PopupBody>
                <div
                    className="issuer-description-content"
                    dangerouslySetInnerHTML={{ __html: issuerDescription }}
                />
            </PopupBody>
            <PopupFooter>
                <button className="btn btn-ghost" onClick={onClose}>
                    Close
                </button>
            </PopupFooter>
        </Popup>
    );
}
